import { PromotionComponent } from './promotion.component';
import { PromotionUpdateComponent } from './promotion-update/promotion-update.component';
import { PromotionCreateComponent } from './promotion-create/promotion-create.component';
import { Routes } from '@angular/router';

export const PROMOTION_ROUTES: Routes = [
    {
        path: 'create',
        component: PromotionCreateComponent,
    },
    {
        path: 'update/:promotionId',
        component: PromotionUpdateComponent,
    },
    {
        path: '',
        component: PromotionComponent,
        data: { section: "TEAM_PROMOTIONS_SECTION" }
    },
];
